import {
  CHANGE_AGREEMENT
} from './types'

export default {
  [CHANGE_AGREEMENT](state) {
    state.isAgree = !state.isAgree;
  }
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/huaweiVIP/store/mutations.js